import ResolvingProcessDataDto from './resolving-process-data-dto';

function generateLineupId(): string {
    return Math.random().toString(16).substring(8);
}

interface State {
    lineupsData: any;
    lateSwap: any;
}

export default interface LineupResolver {
    getResolvingProcessData(state: object): ResolvingProcessDataDto;
}

export class MockLineupResolver implements LineupResolver {
    getResolvingProcessData(state: object): ResolvingProcessDataDto {
        return {
            lineupId: generateLineupId(),
            entryId: '',
        };
    }
}

export class LateSwapLineupResolver implements LineupResolver {
    getResolvingProcessData(state: State): ResolvingProcessDataDto {
        // @ts-ignore
        const {
            lineupsData: {rawLineups},
            lateSwap: {csvLineups},
        } = state;

        const lineupNumber = 1 + rawLineups.getQuantity();

        const lateswapCsvLineup = csvLineups.getOneByNumber(lineupNumber);

        let lineupId = generateLineupId();
        let entryId = '';

        if (lateswapCsvLineup) {
            lineupId = lateswapCsvLineup.getLineupId();
            entryId = lateswapCsvLineup.getEntryId();
        }

        return {lineupId, entryId};
    }
}
